import { render, staticRenderFns } from "./LoginSignUpModal.vue?vue&type=template&id=25b2292f&scoped=true&"
import script from "./LoginSignUpModal.vue?vue&type=script&lang=ts&"
export * from "./LoginSignUpModal.vue?vue&type=script&lang=ts&"
import style0 from "./LoginSignUpModal.vue?vue&type=style&index=0&id=25b2292f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b2292f",
  null
  
)

export default component.exports